import React, { Component } from 'react';
import { connect } from 'react-redux'
import { addSubCategories,selectSubCategory,addMixables,removeMixables,addPreparations,removePreparations,selectPreparation,selectMixable} from '../actions';

import SelectBox from './SelectBox';
import {Link,withRouter} from "react-router-dom";
import Spacer from '../common/Spacer';
import EmptySpacer from '../common/EmptySpacer';
import Button from '../common/Button';
import Option from '../common/Option';
import SelectInput from '../common/SelectInput';
import './second-page.css';

import {api} from '../services';

class SecondPage extends Component {

  constructor(props) {
    super(props);

    this.changeSubCategory = this.changeSubCategory.bind(this);
    this.changePreparation = this.changePreparation.bind(this);
    this.changeMix = this.changeMix.bind(this);
    this.goToTable = this.goToTable.bind(this);
  }

  changeSubCategory(event){
    if(event.target.value == -1){
      return;
    }
    let subCategory = this.props.subcategories[event.target.value];
    this.props.dispatch(selectSubCategory(subCategory));

    this.props.dispatch(removePreparations());
    this.props.dispatch(removeMixables());

    //Load preparations based on subcategory
    api.preparationsFromSubcategory(subCategory.value).then((subcategories) => {
        this.props.dispatch(addPreparations(subcategories));
    });
  }

  changePreparation(event){
    if(event.target.value == -1){
      return;
    }
    this.props.dispatch(removeMixables());
    let prep = this.props.preparations[event.target.value];
    this.props.dispatch(selectPreparation(prep));

    //Load subcategories to combine the selected product with
    api.subcategoriesForPreparation(prep.value).then((subcategories) => {
        this.props.dispatch(addMixables(subcategories))
    });
  }

  changeMix(event){
    if(event.target.value == -1){
      return;
    }
    let mixable = this.props.mixables[event.target.value];
    this.props.dispatch(selectMixable(mixable))
  }

  goToTable(event){
    let subCatId = this.props.subcategorieSelected.value;
    let catId = this.props.match.params.id;
    let location = "/table/" + catId + "/" + subCatId;
    this.props.history.push(location);
  }

  componentDidMount(){

    let id = this.props.match.params.id;

    if(this.props.subcategories.length > 0){

    }else{
      this.props.dispatch(removePreparations());
      this.props.dispatch(removeMixables());

      api.subCategoryFromMain(id).then((subcategories) => {
              this.props.dispatch(addSubCategories(subcategories));
      });
    }
  }

  render() {

    let subcategories = this.props.subcategories;
    let preparations = this.props.preparations;
    let mixables = this.props.mixables;

    let subCatSelected = this.props.subcategorieSelected;
    let mixableSelected = this.props.mixableSelected;
    let preparationSelected = this.props.preparationSelected;

    let subCatIndex = subcategories.findIndex(subCat => subCat.value == subCatSelected.value);
    let prepIndex = preparations.findIndex(prep => prep.value == preparationSelected.value);
    let mixIndex = mixables.findIndex(mix => mix.value == mixableSelected.value);

    return (
      <div className="second-page">
        <div className="second-page-form">

            <SelectBox title="Välj underkategori">
              <SelectInput value={subCatIndex} change={this.changeSubCategory}>
                    <Option value={-1} name="Välj kategori" />
                    {subcategories.map((cat,index) => (
                        <Option key={"subcat:" + index} value={index} name={cat.text} />
                    ))}
              </SelectInput>
            </SelectBox>

            <SelectBox title="Välj preparat">
              <SelectInput value={prepIndex} disabled={preparations.length == 0 ? true :false} change={this.changePreparation} >
                  <Option placeholder value={-1} name="Välj preparat" />
                  {preparations.map((prep,index) => (
                    <Option key={"prep:" + index} value={index} name={prep.text} />
                  ))}
              </SelectInput>
            </SelectBox>

            <Spacer />

            <SelectBox title="Kombineras med">
              <SelectInput value={mixIndex} disabled={mixables.length == 0 ? true : false} change={this.changeMix}>
                <Option placeholder value={-1} name="Välj kategori" />
                {mixables.map((subCat,index) => (
                  <Option key={"mix:" + index} value={index} name={subCat.text} />
                ))}
              </SelectInput>
            </SelectBox>

            <EmptySpacer />

            <Button disabled={Object.entries(mixableSelected).length === 0 ? true : false} click={this.goToTable} text="Visa tabell"/>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  subcategories:state.subcategories.subcategories,
  subcategorieSelected:state.subcategories.selected,
  preparations: state.preparations.preparations,
  preparationSelected:state.preparations.selected,
  mixables:state.mixables.mixables,
  mixableSelected:state.mixables.selected
});

export default withRouter(connect(mapStateToProps)(SecondPage));
